import { graphql, useStaticQuery } from "gatsby"

const useEmailContent = () => {
  const data = useStaticQuery(graphql`
    query {
      allStrapiFormTemplate(filter: { publish: { eq: true } }) {
        nodes {
          choose_template
          name
          content {
            data {
              content
            }
          }
        }
      }
    }
  `)


  return data?.allStrapiFormTemplate?.nodes;
}

export default useEmailContent;